import {
    Container,
    Grid,
    Box,
    ButtonBase,
    makeStyles,
    Card,
    CardMedia,
    CardContent,
    useTheme,
    Slide,
    Typography,
    Hidden,
    useMediaQuery,IconButton,Snackbar,Tooltip 
  } from "@material-ui/core";
  import { useState, useEffect, useRef, useCallback } from "react";
  import parse from "react-html-parser";
  import MuiAlert from "@material-ui/lab/Alert";
  import Axios from "axios";
  import {Link, useParams} from 'react-router-dom';
  import { Helmet } from "react-helmet-async";
  import LinkIcon from '@material-ui/icons/Link';
  import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
  import ChevronRightIcon from '@material-ui/icons/ChevronRight';
  import "yet-another-react-lightbox/styles.css";
  import Lightbox from "yet-another-react-lightbox";
  import { Loading } from "../../components/shared/loading";
  
  import {
    EmailShareButton,
    EmailIcon,
    FacebookShareButton,
    FacebookIcon,
    LinkedinShareButton,
    LinkedinIcon,
    PinterestShareButton,
    PinterestIcon,
   // RedditShareButton,
   // RedditIcon,
    TelegramShareButton,
    TelegramIcon,
    TwitterShareButton,
    TwitterIcon,
   // ViberShareButton,
   XIcon,
    WhatsappShareButton,
    WhatsappIcon,
    RedditIcon,
    RedditShareButton
    
  } from "react-share";

  import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
  
  const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";
  
  const useStyles = makeStyles((theme) => ({
    pageWrapper: {
      background: "#fafafa",
      minHeight: "100vh",
      paddingTop: 40,
      paddingBottom: 60,
    },
    articleContainer: {
      background: "#ffffff",
      borderRadius: 16,
      boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
      overflow: "hidden",
    },
    articleHeader: {
      padding: "32px 32px 24px",
      borderBottom: "1px solid #f0f0f0",
      [theme.breakpoints.down('sm')]: {
        padding: "24px 20px 20px",
      },
    },
    articleDate: {
      fontSize: "0.75rem",
      color: "#6b1b6b",
      fontWeight: 500,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      marginBottom: 12,
    },
    articleTitle: {
      fontSize: "1.5rem",
      fontWeight: 700,
      color: "#1a1a1a",
      lineHeight: 1.3,
      marginBottom: 0,
      [theme.breakpoints.down('sm')]: {
        fontSize: "1.25rem",
      },
    },
    carouselContainer: {
      position: "relative",
      width: "100%",
      backgroundColor: "#f8f4f8",
      overflow: "hidden",
    },
    carouselWrapper: {
      position: "relative",
      width: "100%",
      height: 400,
      [theme.breakpoints.down('sm')]: {
        height: 280,
      },
    },
    carouselSlide: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      opacity: 0,
      transition: "opacity 0.5s ease-in-out",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },
    carouselSlideActive: {
      opacity: 1,
      zIndex: 1,
    },
    carouselImage: {
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain",
    },
    carouselNav: {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 2,
      backgroundColor: "rgba(255,255,255,0.9)",
      color: "#4c004c",
      width: 40,
      height: 40,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      transition: "all 0.2s ease",
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      "&:hover": {
        backgroundColor: "#ffffff",
        transform: "translateY(-50%) scale(1.1)",
      },
      [theme.breakpoints.down('sm')]: {
        width: 32,
        height: 32,
      },
    },
    carouselNavLeft: {
      left: 16,
    },
    carouselNavRight: {
      right: 16,
    },
    carouselDots: {
      position: "absolute",
      bottom: 16,
      left: "50%",
      transform: "translateX(-50%)",
      display: "flex",
      gap: 8,
      zIndex: 2,
    },
    carouselDot: {
      width: 8,
      height: 8,
      borderRadius: "50%",
      backgroundColor: "rgba(255,255,255,0.5)",
      cursor: "pointer",
      transition: "all 0.2s ease",
      border: "1px solid rgba(76,0,76,0.3)",
    },
    carouselDotActive: {
      backgroundColor: "#6b1b6b",
      transform: "scale(1.2)",
    },
    thumbnailGrid: {
      padding: "16px 32px",
      borderBottom: "1px solid #f0f0f0",
      [theme.breakpoints.down('sm')]: {
        padding: "12px 20px",
      },
    },
    thumbnailScroll: {
      display: "flex",
      gap: 12,
      overflowX: "auto",
      paddingBottom: 8,
      "&::-webkit-scrollbar": {
        height: 4,
      },
      "&::-webkit-scrollbar-track": {
        background: "#f0f0f0",
        borderRadius: 2,
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#6b1b6b",
        borderRadius: 2,
      },
    },
    thumbnail: {
      minWidth: 80,
      height: 60,
      objectFit: "cover",
      borderRadius: 8,
      cursor: "pointer",
      transition: "all 0.2s ease",
      border: "2px solid transparent",
      "&:hover": {
        borderColor: "#6b1b6b",
      },
      [theme.breakpoints.down('sm')]: {
        minWidth: 60,
        height: 45,
      },
    },
    thumbnailActive: {
      borderColor: "#6b1b6b",
      boxShadow: "0 0 0 2px rgba(107, 27, 107, 0.3)",
    },
    shareSection: {
      padding: "20px 32px",
      borderBottom: "1px solid #f0f0f0",
      display: "flex",
      alignItems: "center",
      gap: 12,
      flexWrap: "wrap",
      [theme.breakpoints.down('sm')]: {
        padding: "16px 20px",
      },
    },
    shareLabel: {
      fontSize: "0.8rem",
      fontWeight: 600,
      color: "#4c004c",
      marginRight: 8,
    },
    shareButton: {
      transition: "transform 0.2s ease",
      "&:hover": {
        transform: "scale(1.1)",
      },
    },
    articleContent: {
      padding: "32px",
      [theme.breakpoints.down('sm')]: {
        padding: "24px 20px",
      },
    },
    articleBody: {
      fontSize: "0.95rem",
      color: "#333333",
      lineHeight: 1.8,
      "& p": {
        marginBottom: 16,
      },
      "& img": {
        maxWidth: "100%",
        borderRadius: 8,
        margin: "16px 0",
      },
      "& h1, & h2, & h3, & h4": {
        color: "#4c004c",
        marginTop: 24,
        marginBottom: 12,
      },
    },
    quoteSection: {
      background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
      borderRadius: 12,
      padding: "28px 24px",
      marginTop: 32,
      textAlign: "center",
    },
    quoteText: {
      fontSize: "0.9rem",
      color: "#ffffff",
      lineHeight: 1.6,
      fontStyle: "italic",
      maxWidth: 700,
      margin: "0 auto 12px",
    },
    quoteAuthor: {
      color: "#ffffff",
      fontSize: "0.8rem",
      fontWeight: 600,
      opacity: 0.9,
    },
    backLink: {
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      fontSize: "0.85rem",
      color: "#6b1b6b",
      fontWeight: 500,
      textDecoration: "none",
      marginBottom: 20,
      "&:hover": {
        textDecoration: "none",
        color: "#4c004c",
      },
    },
  }));

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  
  
  export const SingleArticle = () => {
    const params = useParams();
    const id = params.id;
    const theme = useTheme();
    const url=window.location.href;
    const isMatch = useMediaQuery(theme.breakpoints.down("md"));
    const classes = useStyles();
    const [data, setData] = useState([]);
    const [metaTitle, setMetaTitle] = useState("");

    const [snackBar, setSnackBar] = useState(false);
    const [snackBarMsg, setSnackBarMsg] = useState("success");
    const [snackBarType, setSnackBarType] = useState("Invalid");
  
    const openSnkbar = (type, msg) => {
      setSnackBarMsg(msg);
      setSnackBarType(type);
      setSnackBar(true);
    };
  
  const [open1, setOpen1] = useState(false);
    const [isloading, setIsloading] = useState(true);
    const [tooSlideImages, setTooSlideImages] = useState([]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isAutoPlaying, setIsAutoPlaying] = useState(true);
    const autoPlayRef = useRef(null);
  
    const [closeOnPullDown, setCloseOnPullDown] = useState(true);
    const [closeOnBackdropClick, setCloseOnBackdropClick] = useState(true);

    // Get images array
    const getImages = useCallback(() => {
      if (data && data.article_images) {
        return data.article_images.split(",");
      }
      return [];
    }, [data]);

    // Auto-slide effect
    useEffect(() => {
      const images = getImages();
      if (images.length > 1 && isAutoPlaying && !isloading) {
        autoPlayRef.current = setInterval(() => {
          setCurrentSlide((prev) => (prev + 1) % images.length);
        }, 4000);
      }
      return () => {
        if (autoPlayRef.current) {
          clearInterval(autoPlayRef.current);
        }
      };
    }, [getImages, isAutoPlaying, isloading]);

    // Navigation functions
    const goToSlide = (index) => {
      setCurrentSlide(index);
      setIsAutoPlaying(false);
      setTimeout(() => setIsAutoPlaying(true), 10000);
    };

    const nextSlide = () => {
      const images = getImages();
      setCurrentSlide((prev) => (prev + 1) % images.length);
      setIsAutoPlaying(false);
      setTimeout(() => setIsAutoPlaying(true), 10000);
    };

    const prevSlide = () => {
      const images = getImages();
      setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
      setIsAutoPlaying(false);
      setTimeout(() => setIsAutoPlaying(true), 10000);
    };

    // Open lightbox starting from current slide
    const openLightbox = () => {
      const images = getImages();
      const reorderedImages = [...images.slice(currentSlide), ...images.slice(0, currentSlide)];
      setTooSlideImages(reorderedImages);
      setOpen1(true);
    };

    const handleClick = () => {
      const anchor = document.querySelector("#back-to-top-anchor");
      if (anchor) {
        anchor.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    };

    const [tooltipText, setTooltipText] = useState("Click to copy the URL");

  const handleCopy = () => {
    // Copy the URL to clipboard
    navigator.clipboard.writeText(window.location.href)
      .then(() => {
        setTooltipText("Link copied to clipboard!"); // Update tooltip text
        setTimeout(() => setTooltipText("Click to copy the URL"), 2000); // Reset tooltip text after 2 seconds
      })
      .catch((err) => console.error("Failed to copy: ", err));
  };
  
    useEffect(() => {
      getMetaData();
    }, []);
  
    const getMetaData = async() => {
        const formdata = new FormData();
        formdata.append("article_id", id);
        Axios
          .post("/api/get_single_article", formdata)
          .then((res) => {
            console.log(res.data.data);
            if (res.data.status === true) {
              setMetaTitle(res.data.data.article_title);
              setData(res.data.data);
              handleClick();
              setIsloading(false);
            }
          }) ;
    };
  
 
  // Function to handle click on any image (other than the first) and open a lightbox with a specific starting index.
  const handleImageClick = (index) => {
    var slideImages = data.article_images.split(",");
    // Rearrange the images array to start from the clicked index and set it for the lightbox.
    var shiftImages = slideImages.splice(0, index + 1);
    slideImages.push(...shiftImages);
    // Set the images for the lightbox and open it.
    setTooSlideImages(slideImages);
    setOpen1(true);
     
  };

   
  
    return (
      <div>
        <Helmet>
          <title>{metaTitle}</title>
           
        </Helmet>
         
       
        {isloading ? (
          <Loading />
        ) : (
          <Box className={classes.pageWrapper}>
            <Container maxWidth="md">
              {/* Back Link */}
              <Link to="/whats-new" className={classes.backLink}>
                ← Back to Articles
              </Link>

              {/* Lightbox */}
              {open1 && (
                <Lightbox
                  open={open1}
                  close={() => setOpen1(false)}
                  slides={tooSlideImages.map((src, index) => ({
                    src: `/static/articles/${src}`,
                    index,
                  }))}
                  controller={{ closeOnPullDown, closeOnBackdropClick }}
                  render={{
                    buttonPrev: tooSlideImages.length > 1 ? undefined : () => null,
                    buttonNext: tooSlideImages.length > 1 ? undefined : () => null,
                  }}
                />
              )}

              {/* Article Card */}
              <Box className={classes.articleContainer}>
                {/* Header */}
                <Box className={classes.articleHeader}>
                  <Typography className={classes.articleDate}>
                    {data.article_published_date}
                  </Typography>
                  <Typography className={classes.articleTitle}>
                    {data.article_title}
                  </Typography>
                </Box>

                {/* Image Carousel */}
                <Box className={classes.carouselContainer}>
                  <Box className={classes.carouselWrapper}>
                    {getImages().map((img, index) => (
                      <Box
                        key={index}
                        className={`${classes.carouselSlide} ${index === currentSlide ? classes.carouselSlideActive : ''}`}
                        onClick={openLightbox}
                      >
                        <img
                          src={`/static/articles/${img}`}
                          alt={`${data.article_title} ${index + 1}`}
                          className={classes.carouselImage}
                        />
                      </Box>
                    ))}

                    {/* Navigation Arrows */}
                    {getImages().length > 1 && (
                      <>
                        <Box 
                          className={`${classes.carouselNav} ${classes.carouselNavLeft}`}
                          onClick={(e) => { e.stopPropagation(); prevSlide(); }}
                        >
                          <ChevronLeftIcon />
                        </Box>
                        <Box 
                          className={`${classes.carouselNav} ${classes.carouselNavRight}`}
                          onClick={(e) => { e.stopPropagation(); nextSlide(); }}
                        >
                          <ChevronRightIcon />
                        </Box>
                      </>
                    )}

                    {/* Dots Indicator */}
                    {getImages().length > 1 && (
                      <Box className={classes.carouselDots}>
                        {getImages().map((_, index) => (
                          <Box
                            key={index}
                            className={`${classes.carouselDot} ${index === currentSlide ? classes.carouselDotActive : ''}`}
                            onClick={(e) => { e.stopPropagation(); goToSlide(index); }}
                          />
                        ))}
                      </Box>
                    )}
                  </Box>
                </Box>

                {/* Thumbnails */}
                {getImages().length > 1 && (
                  <Box className={classes.thumbnailGrid}>
                    <Box className={classes.thumbnailScroll}>
                      {getImages().map((img, index) => (
                        <img
                          key={index}
                          src={`/static/articles/${img}`}
                          alt={`Thumbnail ${index + 1}`}
                          className={`${classes.thumbnail} ${index === currentSlide ? classes.thumbnailActive : ''}`}
                          onClick={() => goToSlide(index)}
                        />
                      ))}
                    </Box>
                  </Box>
                )}

                {/* Share Section */}
                <Box className={classes.shareSection}>
                  <Typography className={classes.shareLabel}>Share:</Typography>
                  <FacebookShareButton url={url} className={classes.shareButton}>
                    <FacebookIcon size={28} round />
                  </FacebookShareButton>
                  <LinkedinShareButton url={url} className={classes.shareButton}>
                    <LinkedinIcon size={28} round />
                  </LinkedinShareButton>
                  <TwitterShareButton url={url} className={classes.shareButton}>
                    <XIcon size={28} round />
                  </TwitterShareButton>
                  <WhatsappShareButton url={url} className={classes.shareButton}>
                    <WhatsappIcon size={28} round />
                  </WhatsappShareButton>
                  <TelegramShareButton url={url} className={classes.shareButton}>
                    <TelegramIcon size={28} round />
                  </TelegramShareButton>
                  <EmailShareButton url={url} className={classes.shareButton}>
                    <EmailIcon size={28} round />
                  </EmailShareButton>
                  <Tooltip title={tooltipText} arrow>
                    <IconButton onClick={handleCopy} size="small">
                      <LinkIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>

                {/* Article Content */}
                <Box className={classes.articleContent}>
                  <Box className={classes.articleBody}>
                    {parse(data.article_desc)}
                  </Box>
                </Box>
              </Box>

              {/* Quote Section */}
              <Box className={classes.quoteSection}>
                <Typography className={classes.quoteText}>
                  "At Arawinz Soft Solutions, we are at the forefront, crafting the future. Each update is a testament to our journey towards excellence, transforming ideas into cutting-edge solutions."
                </Typography>
                <Typography className={classes.quoteAuthor}>
                  — Dr. P. Srinivas Rao, CEO
                </Typography>
              </Box>

              {/* Snackbar */}
              <Snackbar
                open={snackBar}
                autoHideDuration={4000}
                onClose={() => setSnackBar(false)}
              >
                <Alert
                  onClose={() => setSnackBar(false)}
                  severity={snackBarType}
                  style={{ color: snackBarType === "warning" ? "black" : "white" }}
                >
                  {snackBarMsg}
                </Alert>
              </Snackbar>
            </Container>
          </Box>
        )}
     
      </div>
    );
  };
  

